module.exports = __webpack_public_path__ + "static/media/bg-2-art.6acb594d.png";